// extracted by mini-css-extract-plugin
module.exports = {"oauthButtons":"SocialAuthButtons_oauthButtons__hQWyQ","googleBtn":"SocialAuthButtons_googleBtn__AVx84","appleBtn":"SocialAuthButtons_appleBtn__5_dzR"};